import { render, staticRenderFns } from "./SampleBatchContainer.vue?vue&type=template&id=04db7b0e&scoped=true&"
import script from "./SampleBatchContainer.vue?vue&type=script&lang=js&"
export * from "./SampleBatchContainer.vue?vue&type=script&lang=js&"
import style0 from "./SampleBatchContainer.vue?vue&type=style&index=0&id=04db7b0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04db7b0e",
  null
  
)

export default component.exports